import axios from 'axios';
// ---- external imports -----

import { getBaseUrl } from '../lib/helpers';
// ---- parent imports -----

import { getRequestHeaders } from './headers';
import { formatResponse } from './utlis';
import ApiService from './axiosInterceptor.service';
import { INBOX_APIS } from '../endpoints';
// ---- local imports -----

class InboxService {

	getFilterQueryFromApi(apiConfig) {
		const { skip, pageSize } = apiConfig;
		let filters = '';
		Object.entries(apiConfig.filters).map(([filter, values]) => {
			filters += `${filter}=${values.join(',')}&`;
		});
		return `?${filters}skip=${skip}&page_size=${pageSize}`;
	}

	async fetchAllMessages(gameUserId) {
		const response = await ApiService.request({
			method: 'GET',
			headers: getRequestHeaders(),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${INBOX_APIS.GET_MESSAGES}/`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = response.data;

		return formattedResponse;
	}

	async readMessage(gameUserId, messageId) {
		const data = {
			'message_id': messageId
		};

		const response = await ApiService.request({
			method: 'PATCH',
			headers: getRequestHeaders(),
			data: JSON.stringify(data),
			url: `${getBaseUrl()}/game_users/${gameUserId}/${INBOX_APIS.MARK_SEEN}`
		});

		const formattedResponse = formatResponse(response);
		formattedResponse.data = true;

		return formattedResponse;
	}
}

export default new InboxService();
